// @ts-nocheck 0a00e9a7
import _ from 'lodash';
import * as core from '#packages/core';

const utils = core.utils.blogTypeUtils;

export default {
  getSectionPagesDataList(editorAPI, pageDataList) {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line you-dont-need-lodash-underscore/filter
    return _.filter(
      pageDataList,
      _.partial(utils.isBlogSectionPage, editorAPI),
    );
  },

  getSpecialPagesDataList(editorAPI, pageDataList) {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line you-dont-need-lodash-underscore/filter
    return _.filter(pageDataList, utils.isBlogSpecialPage);
  },
};
